import { t } from 'typegate';
export const OptionSizes = {
    full: 'full',
    half: 'half',
    oneThird: 'oneThird',
};
export const optionSize = t.union(t.literal('full'), t.literal('half'), t.literal('oneThird'));
